import { createStore, applyMiddleware, combineReducers } from 'redux'
import reduxThunk from 'redux-thunk'
import logger from 'redux-logger'
import { apiReducers } from './api/reducer'
import { apiOperations as importedApiOperations } from './api'
import { ApiState } from '~/utils/redux-rest-api/reducerHelper'
import { createUseApiSelector, createUseApi } from '~/utils/redux-rest-api/createUseApi'
import { CreateAccountFormState, createAccountFormReducer } from './createAccountForm/reducer'
import { AuthState, authReducer } from './auth/reducer'
export { useApiDispatch } from '~/utils/redux-rest-api/useApiDispatch'

type ReduxApiState = ApiState<typeof apiReducers>
type ApiOperations = typeof importedApiOperations

export type ReduxState = {
  api: ReduxApiState,
  auth: AuthState,
  createAccountForm: CreateAccountFormState
}

const rootReducer = combineReducers<ReduxState>({
  auth: authReducer as any,
  api: combineReducers(apiReducers) as any,
  createAccountForm: createAccountFormReducer
})

const middlewares = []

middlewares.push(reduxThunk)

if (process.env.NODE_ENV !== 'production') {
  middlewares.push(logger)
}

export const store = createStore(rootReducer, applyMiddleware(...middlewares))
export const apiOperations = importedApiOperations
export const useApiSelector = createUseApiSelector<ReduxState, ReduxApiState>(
  (state, requestName) => state.api[requestName]
)
export const useApi = createUseApi<ApiOperations, ReduxApiState>(apiOperations, useApiSelector)
